import { tryToNoticeClientError } from '@/utils/clientErrorInfo';
import { useCallback } from 'react';

export const useGoogleAnalytics = () => {
  return useCallback(
    <TEventKey extends GoogleAnalyticsEventName>(
      eventName: TEventKey,
      eventDetails: GoogleAnalyticsEvents[TEventKey],
    ) => {
      const gtag = typeof window !== 'undefined' ? window?.gtag : undefined;
      if (!gtag) {
        return;
      }

      try {
        gtag('event', eventName, eventDetails);
      } catch (e) {
        // Just push these errors into Sentry, we can't respond to them in any useful way.
        tryToNoticeClientError(e);
      }
    },
    [],
  );
};

export type GoogleAnalyticsEventName = keyof GoogleAnalyticsEvents;

export type GoogleAnalyticsEvents = {
  click_save_job: object;
};
